import axios from "axios";
import {baseUrl_back} from "../../BaseUrl";
export default class GetCodeService {
    static async getCodeData(zid, pod) {
        try {
            const response = await axios.get(`${baseUrl_back}/getCode`, {
                params: {
                    Zapros: zid,
                    Pod: pod,
                    _ts: Date.now(),   // ✅ анти-кэш параметр
                },
                headers: {
                    "Cache-Control": "no-store",
                },
            });

            return response.data;

        } catch (e) {
            console.error("getCodeData error:", e);
            throw e;   // ✅ чтобы наверху можно было перезапросить
        }
    }


    static async getFavorData(uid) {
        try {

            const response = await axios.get(`${baseUrl_back}/getFavorites?uid=`+uid)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }
}




